import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { GetFileType } from '@orbit/api-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UploadFilesVars {
	tripId: string
	files: File[]
	resourceType?: string
	resourceId?: number
}

export function useUploadFiles() {
	const queryClient = useQueryClient()

	return useMutation<GetFileType[], Error, UploadFilesVars>({
		mutationFn: async ({ tripId, files, resourceType, resourceId }) => {
			const formData = new FormData()
			files.forEach(file => formData.append('files', file))

			const params = new URLSearchParams()
			if (resourceType) params.set('resourceType', resourceType)
			if (resourceId !== undefined) params.set('resourceId', String(resourceId))

			const query = params.toString() ? `?${params.toString()}` : ''
			const { data } = await api.post<GetFileType[]>(
				`/trips/${tripId}/files${query}`,
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 },
			)
			return data
		},
		onSuccess: (_data, { tripId, resourceType }) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.files(tripId) })
			if (resourceType === 'ACCOMMODATION') {
				queryClient.invalidateQueries({ queryKey: queryKeys.accommodations(tripId) })
			} else if (resourceType === 'TRIP_EVENT') {
				queryClient.invalidateQueries({ queryKey: queryKeys.events(tripId) })
			} else if (resourceType === 'IDEA') {
				queryClient.invalidateQueries({ queryKey: queryKeys.ideas(tripId) })
			} else if (resourceType === 'FLIGHT_GROUP') {
				queryClient.invalidateQueries({ queryKey: queryKeys.flights(tripId) })
			}
		},
	})
}
